import { DonationTranslation } from 'api/admin/models';
import { createReducer } from 'store/utils';
import { RootActions } from 'store/types';
import { stateFactories, actionsHandlers } from 'store/entities/utils';
import { EntityType } from 'store/entities/types';
import * as actions from './actions';

const stateFactory = stateFactories.createInitialEntitiesStateFactory<EntityType<DonationTranslation>>();
const initialState = stateFactory.getInitialState();

type State = typeof initialState;
type Actions = RootActions<typeof actions>;

const adminDonationTranslationsReducer = createReducer<State, Actions>(initialState, {
  [actions.getAdminDonationTranslation.request.type]: actionsHandlers.handleGetOneRequest,
  [actions.getAdminDonationTranslation.success.type]: actionsHandlers.handleGetOneSuccess,
  [actions.getAdminDonationTranslation.failure.type]: actionsHandlers.handleGetOneFailure,
  [actions.getAdminDonationTranslation.reset.type]: actionsHandlers.handleGetOneReset,
  [actions.updateAdminDonationTranslation.request.type]: actionsHandlers.handleUpdateOneRequest,
  [actions.updateAdminDonationTranslation.success.type]: actionsHandlers.handleUpdateOneSuccess,
  [actions.updateAdminDonationTranslation.failure.type]: actionsHandlers.handleUpdateOneFailure,
  [actions.updateAdminDonationTranslation.reset.type]: actionsHandlers.handleUpdateOneReset,
});

export default adminDonationTranslationsReducer;
